import { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';

import { showToast } from '@components/toast';
import { MessageType } from '@project/enums';

export function PresentationUploader({
  onFileUpload,
  className,
  children,
}: FileUploaderProps): JSX.Element {
  const onDrop = useCallback(
    (acceptedFiles: File[]) => {
      if (acceptedFiles.length === 0) {
        showToast({
          type: MessageType.ERROR,
          message: 'Something went wrong',
        });
        return;
      }
      const file = acceptedFiles[0];

      try {
        onFileUpload(file);
        showToast({
          type: MessageType.SUCCESS,
          message: 'File upload successful',
        });
      } catch (error) {
        showToast({
          type: MessageType.ERROR,
          message: 'Something went wrong',
        });
      }
    },
    [onFileUpload],
  );

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    multiple: false,
    accept: {
      'application/vnd.ms-powerpoint': ['.ppt', '.pptx'],
      'application/vnd.oasis.opendocument.presentation': ['.odp'],
      'application/pdf': ['.pdf'],
    },
  });

  return (
    <div className={className}>
      <div {...getRootProps()}>
        <input {...getInputProps()} />
        {children}
      </div>
    </div>
  );
}
